import NativeIcon from "../../../NativeIcon";
import TabNavigatorPreview from "./TabNavigatorPreview/TabNavigatorPreview";


const TabNavigatorContext={
    name:"context",
    type:"object",
    props:[
        {
            name:"id",type:"string",
            description:"current active tab id",
        },
        {
            name:"label",type:"string",
            description:"current active tab label if specified",
        },
        {name:"tabEl",type:"HTMLButtonElement"},
        {
            name:"contentEl",
            type:"HTMLElement",
            description:"The element returned by tab.renderContent"
        }
    ],
},TabNavigatorTabProps=[
    {name:"id",type:"string"},
    {name:"label",type:"string"},
    NativeIcon,
    {
        name:"memorize",
        type:"boolean",
        description:"Applied to this tab only@overwrites the memorize prop of the component",
    },
    {
        name:"renderContent",
        type:"(props:object):HTMLElement",
        props:[{
            name:"props",type:"object",
            props:[
                {
                    name:"parent",type:"HTMLElement",
                    description:"tab content container",
                },
                TabNavigatorContext,
            ],
        }],
    },
]

export default {
    id:"TabNavigator",
    parent:{name:"View"},
    preview:{
        position:"top",
        component:TabNavigatorPreview,
    },
    props:[
        {name:"headerClassName",type:"string"},
        {
            name:"containerClassName",type:"string",
            description:"tab content container className",
        },
        {
            name:"memorize",
            type:"boolean",
            description:"Applied to all tabs",
        },
        {
            name:"tabs",type:"TabNavigatorTab[]",
            props:[{
                name:"TabNavigatorTab",type:"object",
                props:TabNavigatorTabProps,
            }],
        },
        {
            name:"tintColor",
            type:"string",
            description:`default to "#1e90ff"`,
        },
        {
            name:"tabTextColor",
            type:"string",
            description:`default to "#cecece"`,
        },
        {
            name:"onNavigate",
            type:"(context:object):void",
            props:[TabNavigatorContext],
        },
    ],
    methods:[
        {
            name:"navigate",
            type:"(tabId:string,triggerOnNavigate:boolean):void",
            props:[{
                name:"triggerOnNavigate",
                defaultValue:"true",
                description:"default to true",
            }],
        }
    ],
}
